import React, { useMemo } from 'react'
import ContextMenu, { Position } from 'devextreme-react/context-menu'
import List from 'devextreme-react/list'
import { usePage, router } from '@inertiajs/react'
import { Trans } from 'react-i18next'
import { CirclePlus, Tickets, TicketPlus, MicVocal, Users, Car, Contact, Calendar } from 'lucide-react'
import { renderToStaticMarkup } from 'react-dom/server'
import { can } from '@/utils/index.jsx'
import ScrollView from 'devextreme/ui/scroll_view'
import links from '@/links.json'

export default function AddNewPanel ({ menuMode }) {
  const { auth, app } = usePage().props

  const menuItems = useMemo(() => ([
    {
      text: <Trans i18nKey='labels.access_passes' />,
      icon: renderToStaticMarkup(<Tickets size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_access_passes'),
      url: links.accessControl.accessPasses.create
    },
    {
      text: <Trans i18nKey='labels.access_request_2' />,
      icon: renderToStaticMarkup(<TicketPlus size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_access_requests'),
      url: links.accessControl.accessRequests.create
    },
    {
      text: <Trans i18nKey='labels.invited_persons' />,
      icon: renderToStaticMarkup(<Calendar size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_event_invitations'),
      url: links.accessControl.eventInvitations.create
    },
    {
      text: <Trans i18nKey='labels.accreditations' />,
      icon: renderToStaticMarkup(<MicVocal size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_accreditation_requests'),
      url: links.documents.accreditationRequests.create
    },
    {
      text: <Trans i18nKey='labels.vendor' />,
      icon: renderToStaticMarkup(<Users size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_accounts'),
      url: links.accounts.create
    },
    {
      text: <Trans i18nKey='labels.person_vehicle_check' />,
      icon: renderToStaticMarkup(<Car size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_person_vehicle_check_requests'),
      url: links.documents.personVehicleCheckRequests.create
    },
    {
      text: <Trans i18nKey='labels.contacts' />,
      icon: renderToStaticMarkup(<Contact size={16} color='var(--tw-color-crmPrimary)' />),
      show: can(auth, 'create_contacts'),
      url: links.accounts.contacts.create
    }
  ]), [auth, app.locale])

  const items = useMemo(() => (
    menuItems.filter(i => i.show)
  ),
  [auth, app.locale])

  return (
    <div className='add-new-panel absolute w-full h-full flex items-center justify-center'>
      <CirclePlus size={20} className='text-white' />

      {menuMode === 'context' && (
        <ContextMenu
          items={items}
          target='.add-new-panel-button'
          showEvent='dxclick'
          width={250}
          cssClass='quick-add-new-menu custom-menu-item-link'
          itemRender={(item) => {
            if (item.show) {
              return (
                <a
                  className='!text-inherit dx-item-content dx-menu-item-content'
                  href={item.url}
                  onClick={e => {
                    e.preventDefault()

                    router.visit(item.url)
                  }}
                >
                  {!!item.icon &&
                    <i className='dx-icon dx-svg-icon' dangerouslySetInnerHTML={{ __html: item.icon }} />}

                  <span className='dx-menu-item-text'>{item.text}</span>
                </a>
              )
            }

            return null
          }}
          onItemRendered={(e) => {
            const el = e.itemElement.closest('.dx-submenu')

            if (ScrollView.getInstance(el) === undefined) {
              el.style.height = '250px'
              // eslint-disable-next-line no-new
              new ScrollView(el, { })
            }
          }}
        >
          <Position my={{ x: 'center', y: 'top' }} at={{ x: 'center', y: 'bottom' }} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className='dx-toolbar-menu-action' items={items} />
      )}
    </div>
  )
}
